import Button from 'components/Forms/Button/Button';
import TextInput from 'components/Forms/TextInput/TextInput';
import { StoreServiceFilters } from 'components/Pages/Stores/StoreServiceFilters';
import { StoreTerritorialFilters } from 'components/Pages/Stores/StoreTerritorialFilters';
import { StoreTerritorialUnitType } from 'connectors/stores/StoreLocator';
import useTranslation from 'next-translate/useTranslation';
import { MarkerIcon } from 'public/svg/IconsSvg';
import { ChangeEventHandler } from 'react';
import { StoreServiceFiltersType, StoreServiceIconsType } from 'types/store';

const SEARCH_INPUT_ELEMENT_ID = 'store-search-input';

type StoreLocatorControlsProps = {
    searchValue: string;
    selectedRegion: string;
    selectedDistrict: string;
    territorialUnits: StoreTerritorialUnitType[];
    areTerritorialUnitsLoading: boolean;
    availableServices: StoreServiceFiltersType;
    serviceFilters: StoreServiceFiltersType;
    serviceIcons: StoreServiceIconsType;
    onGeolocation: () => void;
    onSearchChange: (value: string) => void;
    onRegionChange: (value: string) => void;
    onDistrictChange: (value: string) => void;
    onTerritorialSelectorFocus: () => void;
    onServiceFilterChange: (service: keyof StoreServiceFiltersType, isChecked: boolean) => void;
};

export const StoreLocatorControls: FC<StoreLocatorControlsProps> = ({
    searchValue,
    selectedRegion,
    selectedDistrict,
    territorialUnits,
    areTerritorialUnitsLoading,
    availableServices,
    serviceFilters,
    serviceIcons,
    onGeolocation,
    onSearchChange,
    onRegionChange,
    onDistrictChange,
    onTerritorialSelectorFocus,
    onServiceFilterChange,
}) => {
    const { t } = useTranslation();
    const changeSearchHandler: ChangeEventHandler<HTMLInputElement> = (event) => onSearchChange(event.target.value);

    return (
        <div className="mb-5 xl:mb-[35px]">
            <div className="grid gap-3 md:grid-cols-3 xl:grid-cols-[220px_220px_350px_1fr] xl:items-center xl:gap-5 [&_button_svg]:mr-2.5">
                <StoreTerritorialFilters
                    areTerritorialUnitsLoading={areTerritorialUnitsLoading}
                    selectedDistrict={selectedDistrict}
                    selectedRegion={selectedRegion}
                    territorialUnits={territorialUnits}
                    onDistrictChange={onDistrictChange}
                    onRegionChange={onRegionChange}
                    onTerritorialSelectorFocus={onTerritorialSelectorFocus}
                />
                <div className="[&_input[type='text']]:border-primary">
                    <TextInput
                        id={SEARCH_INPUT_ELEMENT_ID}
                        label={t('Store, city, postcode, region or district')}
                        type="text"
                        value={searchValue}
                        onChange={changeSearchHandler}
                    />
                </div>
                <Button
                    className="justify-self-start"
                    size="bigger"
                    type="button"
                    variant="link"
                    onClick={onGeolocation}
                >
                    <MarkerIcon />
                    {t('Find the nearest store')}
                </Button>
            </div>
            <StoreServiceFilters
                availableServices={availableServices}
                serviceFilters={serviceFilters}
                serviceIcons={serviceIcons}
                onServiceFilterChange={onServiceFilterChange}
            />
        </div>
    );
};
